import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isMobileViewport } from './utils/mobile-viewport.utils';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isMobile = isMobileViewport();

    // Allow desktop/tablet
    if (!isMobile) return true;

    // On mobile, redirect to the handoff page
    // Keep the intended URL so you can use it later if needed
    this.router.navigate(['/mobile-desktop'], {
      queryParams: { redirect: state.url },
    });

    return false;
  }
}
